import React from 'react';
import PropTypes from 'prop-types';

import {
    PRODUCT_TYPES,
    CreditCardShape,
    CreditCardLayout,
    useApplyForCreditCardCallback,
} from '@ratehub/cc-common';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import HeadingPropTypes from '../definitions/HeadingPropTypes';
import HeadingBlock from './HeadingBlock';


function ProductSingleCreditCards({
    heading,
    cardInfo,
    productType,
    ...otherProps
}) {
    const applyForCreditCardCallback = useApplyForCreditCardCallback();


    function handleCCCallback() {
        applyForCreditCardCallback({ cardInfo });
    }


    return (
        <div>
            <If condition={heading}>
                <HeadingBlock
                    {...heading}
                />
            </If>

            <CreditCardLayout
                cardInfo={cardInfo}
                productType={productType}
                onClick={handleCCCallback}
                hasEligibilityCTA={true}
                hasBestUsedForPill
                {...otherProps}
            />
        </div>
    );
}

ProductSingleCreditCards.propTypes = {
    heading: HeadingPropTypes,
    cardInfo: CreditCardShape.isRequired,
    productType: PropTypes.oneOf(Object.values(PRODUCT_TYPES)).isRequired,
};

ProductSingleCreditCards.blockKey = 'rh/product-single-credit-cards';
ProductSingleCreditCards.hasHeading = true;
ProductSingleCreditCards.requiresLayoutRow = true;
ProductSingleCreditCards.supportedPageTypes = [ PAGE_TEMPLATES.creditCards ];


export default ProductSingleCreditCards;
